import {
  fetchEditorImagesTags,
  displaySidebarBackgrounds,
  displaySidebarBackgroundsTag,
  loadSelectTagsBackground,
} from '~src/sidebar/index';

import { fetchEditorBackgrounds } from '~graphql/controllers';
import { sidebarLoader } from '~src/sidebar/index';
import { getState } from '~src/state';
import _ from 'lodash';

export const handleSidebarBackgrounds = async (forceFetch = false) => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

  if (_.isEmpty(window.editorConfig.sidebarTags)) {
    const { tags } = await fetchEditorImagesTags();
    window.editorConfig.sidebarTags = tags;
  }

  loadSelectTagsBackground();

  sidebarLoader('editor-sidebar-backgrounds');

  let response = await fetchEditorBackgrounds({
    forceFetch,
  });

  window.editorConfig.sidebarBackgrounds[currentTag] = response.backgrounds;

  displaySidebarBackgrounds();
  displaySidebarBackgroundsTag();
};
